<lib-dropdown-range-values
    [placeholder]="label ? 'Set ' + label : 'Set'"
    [iconType]="iconType"
    [minValue]="minValue"
    [maxValue]="maxValue"
    [(valueFrom)]="selectedValue.from"
    [(valueTo)]="selectedValue.to"
    (applyClicked)="onApplyClicked()"
    (clearClicked)="onClearClicked()"
></lib-dropdown-range-values>
